import util from '../util'

let controller = 'Parceiros'
export default {
  Get: function (id) {
    return util.Axios.Get(controller, id)
  },
  GetAll: function (dto) {
    return util.Axios.GetAll(controller, dto)
  },
  Post: function (dto) {
    return util.Axios.Post(controller, dto)
  },
  Put: function (id, dto) {
    return util.Axios.Put(controller + `/${id}`, dto)
  },
  PutDadosContabeis: function (id, dto) {
    return util.Axios.Put(controller + '/DadosContabeis', id, dto)
  },
  PutPermissaoSolicitacaoCartao: function (id, dto) {
    return util.Axios.Put(controller + '/PermissaoSolicitacaoCartao', id, dto)
  },
  GetComboParceirosBloqueioATF: function () {
    return util.Axios.GetAll(controller + '/GetComboParceirosBloqueioATF')
  },
  GetComboParceirosCartaoConfigurado: function () {
    return util.Axios.GetAll(controller + '/GetComboParceirosCartaoConfigurado')
  },
  CadastrarParceiroSSOCosmos: function (dto) {
    return util.Axios.Post(controller + '/CadastrarParceiroSSOCosmos', dto)
  },
  LimparCacheParceiroSSOCosmos: function (dto) {
    return util.Axios.Post(controller + '/LimparCacheParceiroSSOCosmos', dto)
  },
  GetParceiroPorConta: function (conta) {
    return util.Axios.GetAll(controller + '/GetParceiroPorCodigoConta/' + conta)
  },
  ObterAprovacaoAutomaticaPorCodigoConta(codigoConta) {
    return util.Axios.GetAll(controller + '/ObterAprovacaoAutomaticaPorCodigoConta/' + codigoConta)
  },
  ObterCallbackPorContaParceiro(codigoParceiro, dto) {
    return util.Axios.GetAll(controller + '/'+ codigoParceiro + '/Configuracoes/CallbackPorContaPaginado/', dto)
  },
  CriarCallbackPorContaParceiro(codigoParceiro, dto) {
    return util.Axios.Post(controller + '/'+ codigoParceiro + '/Configuracoes/CallbackPorConta/', dto)
  },
  AtualizarCallbackPorContaParceiro(codigoCallback, dto) {
    return util.Axios.Put(controller + '/Configuracoes/CallbackPorConta',codigoCallback, dto)
  },
  DeletarCallbackPorContaParceiro(codigoCallback) {
    return util.Axios.Delete(controller + '/Configuracoes/CallbackPorConta',codigoCallback)
  },
  GetFrontEnd: function (id) {
    return util.Axios.Get(controller + '/Configuracoes/Frontend', id)
  },
  GetCallback: function (id) {
    return util.Axios.Get(controller + '/Configuracoes/Callback', id)
  },
  GetHeadersCallback: function (id) {
    return util.Axios.Get(controller + '/Configuracoes/HeadersCallback', id)
  },
  GetHeadersHandShake: function (id) {
    return util.Axios.Get(controller + '/Configuracoes/HeadersHandshake', id)
  },
  GetHandshake: function (id) {
    return util.Axios.Get(controller + '/Configuracoes/Handshake', id)
  },
  GetParceirosPaginado: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/Paginado',  dto)
  },
  SalvarCallback: function (id, dto) {
    return util.Axios.Put(controller + '/SalvarCallback', id, dto)
  },
  SalvarHandshake: function (id, dto) {
    return util.Axios.Put(controller + '/SalvarHandshake', id, dto)
  },
  GetParceiroParametrizacao: function (codigoParceiro) {
    return util.Axios.GetAll(controller + `/Parametrizacao/${codigoParceiro}`)
  },
  ObterLogo: function (codigoParceiro, tipo) {
    return util.Axios.GetAll(controller + `/Personalizacao/${codigoParceiro}/${tipo}`)
  },
  PutParametrizacaoParceiro: function (codigoParceiro, dto) {
    return util.Axios.Put(controller + '/Parametrizacao', codigoParceiro, dto)
  },
  PutParceiro(codigoParceiro, dto) {
    return util.Axios.Put(controller, codigoParceiro, dto)
  },
  InserirTermoAberturaConta: function (dto) {
    return util.Axios.Post(controller + '/TermoAberturaConta', dto)
  },
  ObterTermoAberturaConta: function (localArquivoTermoAbertura) {
    return util.Axios.Get(controller + `/TermoAberturaConta?localArquivo=${localArquivoTermoAbertura}`)
  },
  GetParceiroParametrizacao: function (codigoParceiro) {
    return util.Axios.Get(controller + `/Parametrizacao/${codigoParceiro}`);
  },  
  InserirLogo: function (dto) {
    return util.Axios.PostForm(controller + '/Personalizacao/SalvarLogo', dto)
  },
  GetPreview: function (dto) {
    return util.Axios.PostForm(controller + '/Personalizacao/Preview', dto)
  },
  AtualizarPersonalizacao: function (dto) {
    return util.Axios.Put(controller + '/Personalizacao', "", dto)
  },
  GetParceiroComunicacao: function (codigoParceiro) {
    return util.Axios.GetAll(controller + `/Comunicacao/${codigoParceiro}`)
  },
  PutComunicacaoParceiro: function (codigoParceiro, dto) {
    return util.Axios.Put(controller + '/Comunicacao', codigoParceiro, dto)
  },
  PostDominioHabilitado: function (dto) {
    return util.Axios.Post(controller + '/Retaguarda/SalvarDominioHabilitado', dto)
  },
  GetDominioHabilitado: function (codigoParceiro) {
    return util.Axios.Get(controller + `/Retaguarda/GetDominio/${codigoParceiro}`)
  },
  BuscarModeloCobrancaTaxa: function (id) {
    return util.Axios.Get(controller + '/BuscarModeloCobrancaTaxa', id)
  },
  HabilitarOperacoesParceiro: function (dto) {
    return util.Axios.Post(controller + '/HabilitarOperacoesParceiro', dto)
  },
  DesabilitarOperacoesParceiro: function (dto) {
    return util.Axios.Post(controller + '/DesabilitarOperacoesParceiro', dto)
  },
  ParceiroPossuiClientConfigurado: function (codigoParceiro) {
    return util.Axios.Get(controller + `/ParceiroPossuiClientConfigurado/${codigoParceiro}`)
  },
  BuscarDadosOnboarding: function (codigoParceiro) {
    return util.Axios.Get(controller + `/Retaguarda/DadosOnboarding/${codigoParceiro}`)
  },
  AlterarDadosOnboarding: function (dto) {
    return util.Axios.Patch(controller + '/DadosOnboarding', dto)
  },
  ObterLimiteParceiro: function (codigoParceiro) {
    return util.Axios.GetAll(controller + `/Limite/${codigoParceiro}`)
  },
  PersistLimiteParceiro: function (dto) {
    return util.Axios.Persist(controller + '/Limite', dto)
  }
}
